export const agreementLengthConstants = {
  ID: 'id',

  NAME: 'name',
  NAME_LABEL: 'Name',

  ORDER: 'order',
  ORDER_LABEL: 'Order',

  LENGTH: 'length',
  LENGTH_LABEL: 'Length',

  UNIT: 'unit',
  UNIT_LABEL: 'Unit',

  SEARCH: 'Search Agreement Lengths',
};
